import { render, staticRenderFns } from "./ContainerBrackets.vue?vue&type=template&id=47a94533&scoped=true&lang=pug&"
import script from "./ContainerBrackets.vue?vue&type=script&lang=js&"
export * from "./ContainerBrackets.vue?vue&type=script&lang=js&"
import style0 from "./ContainerBrackets.vue?vue&type=style&index=0&id=47a94533&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a94533",
  null
  
)

export default component.exports